import { useTranslation } from 'react-i18next';
import {
  Table,
  TableBody,
  TableCell,
  TableCellHead,
  TableHead,
  TableRow,
} from '~/ui/Table';
import PointsBadge from './PointsBadge/PointsBadge';
import dayjs from 'dayjs';
import styles from './PointsTable.module.scss';
import { useNavigate } from 'react-router-dom';
import { getPaginate } from '~/utils/getPaginate';
import { paginateEnums } from '~/utils/types/paginateEnums';
import TooltipText from '~/components/Shared/TooltipText/TooltipText';

interface IPromoLoyalty {
  name: string;
  description: string;
  start_date: string;
}

interface IUser {
  full_name: string;
  name: string;
  patronymic: string;
  email: string;
}

interface IGameTournament {
  id: number;
  name: string;
}

interface IPointsProps {
  points: {
    id: number;
    user_id: number;
    points: number;
    promo_loyalty: IPromoLoyalty;
    game_tournament: IGameTournament | null;
    text: string | null;
    user: IUser;
    created_at: string;
  }[];
  sort: { field: string; direction: string };
  setSort: ({ field, direction }: { field: string; direction: string }) => void;
}

const PointsTable = ({ points, sort, setSort }: IPointsProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { value, paginate } = getPaginate(
    paginateEnums.HISTORY_LOYALTY_PAGINATE
  );

  return (
    <Table>
      <TableHead sort={sort} setSort={setSort}>
        <TableCellHead field="user_id">{t('employee')}</TableCellHead>
        <TableCellHead field="email" sortable={false}>
          {t('email')}
        </TableCellHead>
        <TableCellHead field="created_at">{t('date_and_time')}</TableCellHead>
        <TableCellHead field="promo_loyalty_id">{t('stock')}</TableCellHead>
        <TableCellHead className={styles.pointsHead} field="points">
          {t('accrued_points')}
        </TableCellHead>
      </TableHead>
      <TableBody>
        {!!points.length &&
          points.map(item => (
            <TableRow
              key={item.id}
              onClick={() =>
                navigate(`/user/${item.user_id}?${value}=${paginate}`)
              }
              style={styles.row}
            >
              <TableCell>
                {`${item?.user?.name} ${item?.user?.patronymic}`}
              </TableCell>
              <TableCell>{item?.user?.email}</TableCell>
              <TableCell>
                {dayjs(item.created_at).format('DD.MM.YYYY HH:mm')}
              </TableCell>
              <TableCell className={styles.descriptionCell}>
                <TooltipText
                  text={
                    item?.game_tournament
                      ? `${t('tournament_accrual')}: ${item.game_tournament.name}`
                      : item?.text || item?.promo_loyalty?.name
                  }
                />
              </TableCell>
              <TableCell className={styles.points}>
                <PointsBadge point={item?.points} />
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
};

export default PointsTable;
